import {UnitSystem} from "@/interfaces/units";
import {
  DesignScenarioType,
  EsalCalculationMethods, IDesignBaseScenario
} from "@/modules/design/interfaces/shared";

export enum StructuralEvaluationMethods {
  survey = 'SURVEY',
  testing = 'TESTING'
}

export interface IAcOverlayLayerImperial {
  // unitSystem: UnitSystem.Imperial,
  id?: number | null,
  type: string,
  thickness_in: number,
  layerCoefficient: number | null,
  drainageCoefficient: number,
  sn: number
}

export interface IAcOverlayLayerMetric{
  // unitSystem: UnitSystem.Metric,
  id?: number | null,
  type: string,
  thickness_cm: number,
  layerCoefficient: number | null,
  drainageCoefficient: number,
  sn: number
}

export interface AcOverlayDesignBase extends IDesignBaseScenario {
  designScenarioType: DesignScenarioType.acOverlay,

  //IDesignBaseScenario information
  description: string | null,
  state: string | null,


  // Pavement Design
  completionYear: number | null, // Years
  roadwayClassification: string | null,
  pavementType: string | null,

  // Layers
  subgradeSoilType: string | null,
  subgradeRValue: number | null,
  subgradeCbr: number | null,
  existingLayerCoeff: number | null,
  modulusCalculationMethod: string | null,

  // Structural Eval
  structuralEvaluationMethod: StructuralEvaluationMethods

  // Condition Survey
  coresTaken: boolean | null,
  crackCoresTaken: boolean | null,
  topDownCracking: string | null,
  stripping: boolean |null,

  alligatorLow: string | null,
  alligatorMed: string | null,
  alligatorHigh: string | null,

  transverseLow: string | null,
  transverseMed: string | null,
  transverseHigh: string | null,

  millRemoveDistressed: boolean | null,

  // Nondestructive testing
  combinedLayerStiffness: number | null,
  estimatedStructuralCoefficient: number | null,

  // Design Parameters
  designPeriod_years: number | null, // Years
  reliabilityLevel: number | null, // Unitless, Standard Normal Deviate
  standardError: number | null, // Unitless,

  initialServiceability: number | null, // Present Servicability Index (p_i)
  terminalServiceability: number | null, // Present Servicability Index at EOL(p_t)
  deltaServiceability: number | null, // TODO: Redundant -> calculated???

  // Traffic and Loading
  esalCalculatedFrom: EsalCalculationMethods,

  // From AADT
  initialTraffic: number | null, // Completion year traffic
  trafficGrowthRate: number | null,
  esalGrowthRate: number | null,

  //From ESALs
  esals: number | null,
  loadEquivalencyFactor: number | null,

  //From Design ESALs
  totalDesignEsals: number | null,
}

export interface IAcOverlayDesignImperial extends AcOverlayDesignBase {
  unitSystem: UnitSystem.Imperial,

  // Pavement Layers
  existingLayers: IAcOverlayLayerImperial[]
  subgradeModulus_psi: number | null,
  overlayLayerMinimumThickness_in: number | null,

  // Condition Survey
  crackDepth_in: number | null,
  distressDepth_in: number | null,
  removeDepth_in: number | null,

  // Nondestructive testing
  designSubgradeModulus_psi: number | null,

}

// export interface IPorousDesignImperial extends NewConcreteDesignScenarioInputs{ }

export interface IAcOverlayDesignMetric extends AcOverlayDesignBase{
  unitSystem: UnitSystem.Metric,

   // Pavement Layers
  existingLayers: IAcOverlayLayerMetric[]
  subgradeModulus_mpa: number | null,
  overlayLayerMinimumThickness_cm: number | null,

  // Condition Survey
  crackDepth_cm: number | null,
  distressDepth_cm: number | null,
  removeDepth_cm: number | null,

  // Nondestructive testing
  designSubgradeModulus_mpa: number | null,
}
